export default __webpack_public_path__ + "static/media/Offers.6cad6da7.webp";